import type { Column } from "@tanstack/react-table";
import { ArrowUpDown } from "lucide-react";
import * as React from "react";

import { DataTableButton } from "@/components/ui/data-table-button";
import { cn } from "@/lib/utils";

export interface DataTableColumnHeaderProps<TData, TValue> {
  column: Column<TData, TValue>;
  title: string;
  align?: "left" | "right";
  className?: string;
}

/** Sortable header control — matches shadcn data-table docs (ghost + ArrowUpDown). */
export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  align = "left",
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  const control = (
    <DataTableButton
      variant="ghost"
      size="sm"
      data-trade-log-column-header=""
      data-column-header-align={align === "right" ? "right" : undefined}
      className={cn(
        "h-8 max-h-8 min-h-8 gap-2 px-3",
        align === "right" && "tabular-nums",
        className
      )}
      onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
    >
      {title}
      <ArrowUpDown className="size-4 shrink-0 text-[color:var(--brand-tropical-surf)]" />
    </DataTableButton>
  );

  if (align === "right") {
    return (
      <div data-column-header-align="right" className="flex w-full justify-end">
        {control}
      </div>
    );
  }

  return control;
}
